<template>
  <el-dialog title="Shipping Detail" :visible.sync="domVisible" width="480px" :lock-scroll="false" :before-close="handleClose">
    <div class="shipping_box">

      <el-scrollbar>
      <div  class="shippingScroll">
        <div class="shipping_f color_333">
          <div class="shipping_title color_333">{{ $t('base.domesticShipping') }}</div>
          <span class="color_333" v-if="list.DomesticCustom[0].Status==1">{{ $t('base.freeShipping') }}</span>
          <span class="color_333" v-if="list.DomesticCustom[0].Status==2">{{ $t('base.payOnDelivery') }}</span>
          <span class="color_333" v-if="list.DomesticCustom[0].Status==3">{{areaSymbol}} {{list.DomesticCustom[0].USD_Price}}</span>
          <!-- <span class="shipping_cost">Free Shipping</span> -->
        </div>
        <div v-for="(item,index) in list.DomesticCustom" :key="index" v-if="index>0">
          <div class="cost_l color_333">
            <div class="locations color_333">{{ $t('base.otherLocations') }}</div>
            <span v-if="item.Status==1">{{ $t('base.freeShipping') }}</span>
            <span v-if="item.Status==2">{{ $t('base.payOnDelivery') }}</span>
            <span v-if="item.Status==3">{{areaSymbol}} {{item.USD_Price}}</span>
          </div>
          <span class="color_aoao address">{{item.AreaName}}</span>
        </div>
        <!-- <div>
            <div class="cost_l">
            <div class="locations color_333">Excluded locations</div>
            <span>$ 20</span>
          </div>
          <span class="color_aoao address">California</span>
          </div> -->
      </div>

      </el-scrollbar>
      <div>
        <div class="shipping_title shipping_title_t color_333">{{ $t('base.internationalShipping') }}</div>
        <span class="color_aoao address international_s">{{ $t('alert.buyerPays') }}</span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">{{ $t('base.done') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
    }
  },
  props: {
    domVisible: Boolean,
    list: {},
  },
  watch: {},
  filters: {},
  created() {
    console.log(this.domVisible, 'domVisible')
    console.log(this.list, 'list')
  },
  methods: {
    handleClose() {
      this.$emit('getDialog', false)
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-dialog__body {
  padding: 12px 40px;
}
/deep/ .el-dialog__title{
  color: #333;
}
.shippingScroll{
  min-height:200px;
  max-height: 50vh;
  padding-right: 15px;
}
/* .shipping_box {
  padding: 12px 40px;
} */

.shipping_title {
  height: 18px;
  font-size: 16px;
}

.shipping_title_t {
  margin: 24px 0 0;
}

.shipping_cost {
  height: 18px;
  color: #f0ad4e;
  border: #f0ad4e 1px solid;
  border-radius: 3px;
  padding: 0 4px;
  margin: 0 0 0 8px;
}

.locations,
.cost_l span {
  height: 16px;
  margin: 16px 0 12px;
}

.color_aoao {
  min-height: 16px;
}

.address {
  display: block;
  /* margin-top: 16px; */
}

.international_s {
  margin-top: 16px;
}

.shipping_f {
  justify-content: space-between;
}

.shipping_f,
.ship_return,
.cost_l {
  display: flex;
}

.cost_l {
  justify-content: space-between;
}

.ship_return > div:first-child {
  width: 20%;
}

.ship_return > div:last-child {
  width: 80%;
}

.ship_return > div:last-child div {
  margin-bottom: 10px;
}

.ship_return .text_gray {
  font-size: 12px;
}

.ship_last_line {
  /* border-bottom: 1px solid #f0f0f0; */
  margin-bottom: 10px;
}

.ship_last_line2 {
  border-bottom: none;
}

.see {
  border-left: 1px solid;
  margin-left: 10px;
  padding-left: 10px;
}

.ship_return h5 {
  font-size: 24px;
}

.ship_return h5 .bids_box {
  font-size: 14px;
  font-weight: normal;
  margin-left: 25px;
  display: inline-block;
}

.line_last {
  padding: 0;
}

.no_line {
  border-bottom: none;
}

.Payments {
  height: 16px;
  display: block;
  background: url(../../../static/images/paypal2.png) no-repeat;
  background-size: 16.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/domestic.vue